import React from 'react';
import { Link } from 'react-router-dom';
import { setAnalyticsConsent } from '../utils/analyticsConsent';
import { useAnalyticsConsent } from '../hooks/useAnalyticsConsent';
import { ANALYTICS_CONFIGURED } from '../utils/analyticsConfigured';

/**
 * Consent gate for analytics egress (SEC-6). Renders a dismissible banner until
 * the visitor makes a choice; analytics does not load until they Accept. The
 * choice is persisted, so the banner does not reappear on subsequent visits.
 */
export default function ConsentBanner() {
  const status = useAnalyticsConsent();

  if (!ANALYTICS_CONFIGURED || status !== null) return null;

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label="Analytics consent"
      className="mk-consent fixed inset-x-0 bottom-0 z-50 px-4 pb-4 sm:px-6 sm:pb-6"
    >
      {/* Bottom-LEFT and narrow, not a centred full-width bar. The public
          landing page is a single screen whose only purpose is the "Join the
          waitlist" button, and that button is right-aligned in the hero: a
          centred max-w-3xl bar sat directly on top of it, so the one thing the
          page exists to offer was covered until the visitor dealt with a cookie
          notice. Consent is unchanged - same text, same two explicit choices,
          still nothing sent before a decision. */}
      <div
        className="max-w-md p-5 sm:p-6 border rounded-2xl"
        style={{
          backgroundColor: 'var(--gh-bone)',
          borderColor: 'var(--gh-rule)',
          boxShadow: '0 24px 60px rgba(61, 11, 13, 0.22)',
        }}
      >
        <p className="gh-eyebrow mb-2">Your privacy</p>
        <p className="text-sm mb-4" style={{ color: 'var(--gh-graphite)' }}>
          We&rsquo;d like to use Google Analytics to understand how the site is used so we can
          improve it. These analytics cookies send limited usage data to Google, including to
          servers in the United States. Nothing is sent until you choose. See our{' '}
          <Link to="/privacy" className="gh-link">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
          <button
            type="button"
            onClick={() => setAnalyticsConsent('denied')}
            className="gh-btn-secondary"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => setAnalyticsConsent('granted')}
            className="gh-btn-primary"
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}
